import { select, Store } from "@ngrx/store";
import { AppState } from "../../reducers";
import { BaseDataSource, QueryResultsModel } from "../../_base/crud";
import { selectOfficeAdjustmentQueryResult, selectOfficeAdjustmentsPageLoading, selectOfficeAdjustmentsShowInitWaitingMessage } from "../_selectors/office-adjustments.selectors";

export class OfficeAdjustmentsDataSource extends BaseDataSource {
    trashed = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectOfficeAdjustmentsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectOfficeAdjustmentsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectOfficeAdjustmentQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        })
        
    }
}